// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"32":"4a211087","101":"7730f544","265":"44c485a7","810":"0c843064"}[chunkId] + ".chunk.css";
};